<template>
  <div
    row
    wrap
    class="account-detail-component"
  >
    <v-expansion-panel
      v-model="panel"
      class="my-2"
      expand
    >
      <!-- Information start -->
      <v-expansion-panel-content>
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              assignment_ind
            </v-icon>
            Account Information
          </h6>
        </template>
        <v-card>
          <v-container
            fluid
            grid-list-sm
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                xs6
                sm4
              >
                <v-text-field
                  v-model="account.depot.empf"
                  :label="'Person'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
              <v-flex
                xs6
                sm2
              >
                <v-text-field
                  v-model="account.depot.user_id"
                  :label="'UserID'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
              <v-flex
                xs6
                sm2
              >
                <v-text-field
                  v-model="account.depot.snr"
                  :label="'SNR'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
              <v-flex
                xs6
                sm2
              >
                <v-text-field
                  v-model="account.depot.kto"
                  :label="'AccountNumber'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <v-text-field
                  v-model="account.depot.iban"
                  :label="'IBAN Depot'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
              <v-flex
                xs12
                md6
              >
                <v-text-field
                  v-model="account.depot.ktok"
                  :label="'IBAN User Reference Account'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs6
                md3
              >
                <v-text-field
                  :value="formatDate(account.depot.openingDate)"
                  :label="'Opening date'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
              <v-flex
                class="saldo-payout"
                xs6
                md3
                @click="openPayoutModal"
              >
                <v-text-field
                  :value="account.saldo.saldo | currency('€')"
                  :label="'Current Saldo'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
              <v-flex
                xs6
                md3
              >
                <v-text-field
                  :value="account.depot.open_payouts | currency('€')"
                  :label="'Open Payouts'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-radio-group
                  v-model="automatic_payout"
                  label="Automatic Payout"
                  row
                  wrap
                >
                  <v-radio
                    v-for="option in settingArray"
                    :key="option.value"
                    :label="option.name"
                    :value="option.value"
                    color="info"
                    @change="changeSetting('automatic_payout', option.value)"
                  />
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-expansion-panel-content>
      <!-- Exemption Order Start -->
      <v-expansion-panel-content v-if="account.exemptionOrder">
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              assignment_ind
            </v-icon>
            Exemption Order
          </h6>
        </template>
        <v-card>
          <v-container
            fluid
            grid-list-sm
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                xs6
                sm4
              >
                <v-text-field
                  :value="account.exemptionOrder.frart"
                  :label="'FR-Art'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
              <v-flex
                xs6
                md3
              >
                <v-text-field
                  :value="account.exemptionOrder.openAmount | currency('€')"
                  :label="'Open Amount'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
              <v-flex
                xs6
                md3
              >
                <v-text-field
                  :value="account.exemptionOrder.usedAmount | currency('€')"
                  :label="'Used Amount'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
              <v-flex
                xs6
                md3
              >
                <v-text-field
                  :value="formatDate(account.exemptionOrder.validUntil)"
                  :label="'Valid Until'"
                  :readonly="true"
                  color="blue"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-expansion-panel-content>
      <!-- Exemption Order End -->
      <!-- Stocks start -->
      <v-expansion-panel-content>
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              assignment_ind
            </v-icon>
            Stocks
            <b>({{ account.stocks ? account.stocks.length || 0 : 0 }})</b>
          </h6>
        </template>
        <v-data-table
          :headers="stocksHeaders"
          :items="account.stocks"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                {{ props.item.asset }}
              </td>
              <td class="text-xs-center">
                {{ props.item.wpNr }}
              </td>
              <td class="text-xs-center">
                {{ props.item.nwm | currency('€') }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
      <!-- Stocks end -->
      <!-- Revenues start -->
      <v-expansion-panel-content>
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              assignment_ind
            </v-icon>
            Revenues
            <b>({{ account.revenues ? account.revenues.length || 0 : 0 }})</b>
          </h6>
        </template>
        <v-data-table
          :headers="revenuesHeaders"
          :items="account.revenues"
          :pagination.sync="pagination"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                {{ props.item.importDate }}
              </td>
              <td class="text-xs-center">
                {{ formatDate(props.item.valutaDate) }}
              </td>
              <td class="text-xs-center">
                {{ props.item.umart }}
              </td>
              <td class="text-xs-center">
                {{ getCorrectPurpose(props.item) }}
                <span v-if="props.item.iban">
                  <br>
                  {{ props.item.iban }} {{ props.item.bic }}
                </span>
              </td>
              <td class="text-xs-center">
                {{ props.item.saldo | currency('€') }}
              </td>
              <td>
                <v-tooltip
                  v-if="props.item.documentId"
                  top
                  dark
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="warning"
                      flat
                      icon
                      v-on="on"
                      @click="download(props.item)"
                    >
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </template>
                  <span>download</span>
                </v-tooltip>
                <v-tooltip
                  v-if="props.item.documentId"
                  top
                  dark
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="blue"
                      flat
                      icon
                      v-on="on"
                      @click="preview(props.item)"
                    >
                      <v-icon>preview</v-icon>
                    </v-btn>
                  </template>
                  <span>preview</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
      <!-- Revenues end -->
      <!-- Payouts start -->
      <v-expansion-panel-content>
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              assignment_ind
            </v-icon>
            Payouts
            <b>({{ account.payouts ? account.payouts.length || 0 : 0 }})</b>
          </h6>
        </template>
        <v-data-table
          :headers="payoutsHeaders"
          :items="account.payouts"
          :pagination.sync="pagination"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                {{ formatDate(props.item.created_at) }}
              </td>
              <td class="text-xs-center">
                {{ props.item.payout.status }}
              </td>
              <td class="text-xs-center">
                {{ formatDate(props.item.payout.upload_date) }}
              </td>
              <td class="text-xs-center">
                {{ props.item.amount | currency('€') }}
              </td>
              <td class="text-xs-center">
                {{ props.item.automatic_payout }}
              </td>
              <td class="text-xs-center">
                {{ props.item.success }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
      <!-- Payouts end -->
      <!-- Transactions start -->
      <v-expansion-panel-content>
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              assignment_ind
            </v-icon>
            Transactions
            <b>({{ account.transactions ? account.transactions.length || 0 : 0 }})</b>
          </h6>
        </template>
        <v-data-table
          :headers="transactionsHeaders"
          :items="account.transactions"
          :pagination.sync="pagination"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                {{ props.item.importDate }}
              </td>
              <td class="text-xs-center">
                {{ props.item.wpGart }}
              </td>
              <td class="text-xs-center">
                {{ props.item.asset }}
              </td>
              <td class="text-xs-center">
                {{ props.item.wpNr }}
              </td>
              <td class="text-xs-center">
                {{ props.item.nw | currency('€') }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- Transactions end -->
    <create-payout
      :dialog="isOpenPayoutModal"
      :user-id="account.depot.user_id"
      :saldo="parseFloat(account.saldo.saldo)"
      :open-payouts="parseFloat(account.depot.open_payouts)"
      :cancel-action="cancelPayoutModal"
      :submit-action="submitCreatePayout"
      :create-payout-error="createPayoutError"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { settingArray } from '@/enum/baader/Setting';
import CreatePayout from './CreatePayout';

export default {
  name: 'AccountDetailComponent',
  components: {
    'create-payout': CreatePayout,
  },
  props: {
    account: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 5,
        sortBy: 'importDate',
        descending: true,
      },
      stocksHeaders: [
        {
          text: 'Project',
          align: 'left',
          value: 'user_id',
        },
        {
          text: 'WpNr',
          align: 'left',
          value: 'name',
        },
        {
          text: 'Amount',
          align: 'left',
          value: 'snr',
        },
      ],
      revenuesHeaders: [
        {
          text: 'Import Date',
          align: 'left',
          value: 'importDate',
        },
        {
          text: 'Valuta Date',
          align: 'left',
          value: 'valutaDate',
        },
        {
          text: 'Umart',
          align: 'left',
          value: 'umart',
        },
        {
          text: 'Purpose',
          align: 'left',
          value: 'purpose',
        },
        {
          text: 'Amount',
          align: 'left',
          value: 'saldo',
        },
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
        },
      ],
      payoutsHeaders: [
        {
          text: 'Created_at',
          align: 'left',
          value: 'created_at',
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status',
        },
        {
          text: 'Upload Date',
          align: 'left',
          value: 'upload_date',
        },
        {
          text: 'Amount',
          align: 'left',
          value: 'amount',
        },
        {
          text: 'AutomaticPayout',
          align: 'left',
          value: 'automatic_payout',
        },
        {
          text: 'Success',
          align: 'left',
          value: 'success',
        },
      ],
      transactionsHeaders: [
        {
          text: 'Import Date',
          align: 'left',
          value: 'importDate',
        },
        {
          text: 'Umart',
          align: 'left',
          value: 'umart',
        },
        {
          text: 'Project',
          align: 'left',
          value: 'asset',
        },
        {
          text: 'WpNr',
          align: 'left',
          value: 'wpnr',
        },
        {
          text: 'Amount',
          align: 'left',
          value: 'amount',
        },
      ],
      panel: 0,
      settingArray,
      automatic_payout: this.account.settings ? this.account.settings.automatic_payout : 0,
      isOpenPayoutModal: false,
      createPayoutError: '',
    };
  },
  methods: {
    ...mapActions([
      'updateSetting',
      'createPayoutItem',
      'downloadDocument',
    ]),
    formatDate(date) {
      return date ? this.$moment(date).format('YYYY-MM-DD') : null;
    },
    getCorrectPurpose(revenue) {
      return revenue.asset !== null ? revenue.asset : revenue.purpose;
    },
    async changeSetting(setting, value) {
      const updateData = {};
      updateData.setting = setting;
      updateData.value = value;
      updateData.userId = this.account.depot.user_id;
      await this.updateSetting(updateData);
    },
    openPayoutModal() {
      this.isOpenPayoutModal = true;
    },
    cancelPayoutModal() {
      this.isOpenPayoutModal = false;
      this.createPayoutError = '';
    },
    async submitCreatePayout(data) {
      try {
        await this.createPayoutItem(data);
        this.$emit('payoutItemCreated');
        this.isOpenPayoutModal = false;
      } catch (e) {
        console.error(e);
        this.createPayoutError = 'Fehler bei der Payout-Erstellung';
        this.isOpenPayoutModal = true;
      }
    },
    async preview(revenue) {
      this.downloadDocument(revenue.documentId).then((response) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        window.open(window.URL.createObjectURL(blob));
      });
    },
    async download(revenue) {
      this.downloadDocument(revenue.documentId).then((response) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = revenue.documentName;
        link.click();
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.subheading {
  color: grey;
}
.saldo-payout:hover{
   cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/baader/AccountDetailComponent.vue